import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { useMobileDialogStyle } from "../hooks/useVisualViewport";

const hm = (iso) => (iso ? String(iso).slice(11, 16) : "");

// Resolution dialog for a "Da confermare" activity: register the REAL times (default = planned) and
// confirm, or mark it not performed. NO autofocus. planned_start/planned_end are shown, not editable.
export function ActivityConfirmDialog({ open, item, onConfirm, onSkip, onClose }) {
  const dlgStyle = useMobileDialogStyle();
  const [startHM, setStartHM] = useState("");
  const [endHM, setEndHM] = useState("");
  const [err, setErr] = useState("");
  useEffect(() => {
    if (open && item) {
      setStartHM(hm(item.actual_start_at) || hm(item.start_at) || item.time || "");
      setEndHM(hm(item.actual_end_at) || hm(item.expected_end_at) || "");
      setErr("");
    }
  }, [open, item]);
  if (!item) return null;
  const date = item.date;
  const pS = hm(item.start_at) || item.time || "";
  const pE = hm(item.expected_end_at) || "";
  const confirm = () => {
    if (!startHM) { setErr("Inserisci l'ora di inizio"); return; }
    const asa = `${date}T${startHM}:00`;
    const aend = endHM ? `${date}T${endHM}:00` : null;
    if (aend && aend < asa) { setErr("L'ora di fine non può precedere l'ora di inizio."); return; }
    onConfirm({ actual_start_at: asa, actual_end_at: aend });
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="activity-confirm-dialog" style={dlgStyle} className="max-w-[400px]">
        <DialogHeader>
          <DialogTitle>{item.horse_name}</DialogTitle>
          <DialogDescription>
            {item.activity_type_label}{item.assignee_name ? ` · ${item.assignee_name}` : ""}
            {pS ? <><br />Programmata {pS}{pE ? `–${pE}` : ""}</> : null}
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label className="text-xs">Orario inizio</Label>
            <Input type="time" data-testid="confirm-start-input" value={startHM} onChange={(e) => { setStartHM(e.target.value); setErr(""); }} className="mt-1 h-11" />
          </div>
          <div>
            <Label className="text-xs">Orario fine</Label>
            <Input type="time" data-testid="confirm-end-input" value={endHM} onChange={(e) => { setEndHM(e.target.value); setErr(""); }} className="mt-1 h-11" />
          </div>
        </div>
        {err && <p className="text-xs text-red-600" data-testid="confirm-error">{err}</p>}
        <DialogFooter className="gap-2 sm:justify-between">
          <Button variant="outline" data-testid="confirm-skip" onClick={onSkip} className="border-red-300 text-red-600 hover:bg-red-50">Non effettuata</Button>
          <Button data-testid="confirm-submit" onClick={confirm} className="bg-[#1B3B2B] hover:bg-[#142E1F]">Conferma</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
